<div class="article-counter ml-2 d-inline-flex align-items-center justify-content-center">
  <div class="cursor-pointer rounded-circle circle bg-white minus d-flex align-items-center justify-content-center" (click)="onDecreaseQuantity() ;$event.stopPropagation()"
    [ngClass]="{'opacity-3 pointer-events-none': (numberOfAddedProducts < 1)}">
    <i class="icon13 se-icon no-select top-0 font-size-32 font-weight-semibold"
       [ngClass]="{'opacity-6 pointer-events-none':(numberOfAddedProducts < 1)}">electricity_polarity_negative_minus</i>
  </div>
  <input
    type="number"
    appNumericValidationDirective
    class="counter-input border-radius-4 mr-0 font-size-14 text-center"
    (click)="$event.stopPropagation()"
    [min]="0"
    [max]="maxNumberOfElements"
    [(ngModel)]="numberOfAddedProducts"
    (sanitizedChange)="changeNumberOfProducts()" />
  <div
    class="cursor-pointer rounded-circle circle bg-white plus d-flex align-items-center justify-content-center" (click)="onIncreaseQuantity();$event.stopPropagation()"
    [ngClass]="{'opacity-3 pointer-events-none': (numberOfAddedProducts >= maxNumberOfElements)}">
    <i class="icon13 se-icon-electricity_polarity_positive_plus no-select top-0 font-size-32 font-weight-semibold"
       [ngClass]="{'opacity-6 pointer-events-none':(numberOfAddedProducts >= maxNumberOfElements)}"></i>
  </div>
</div>
